module.exports = __webpack_public_path__ + "img/icon_blue-big_bell.e1e342fb.svg";